import { render } from "./DiscoverItem.vue?vue&type=template&id=caf3f9e2&scoped=true"
import script from "./DiscoverItem.vue?vue&type=script&lang=js"
export * from "./DiscoverItem.vue?vue&type=script&lang=js"

import "./DiscoverItem.vue?vue&type=style&index=0&id=caf3f9e2&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf3f9e2"]])

export default __exports__